import { create } from 'zustand';

type OpenTimModalParams = {
  campaignId?: string | number | null;
  orderId?: string | number | null;
};

type TimModalStore = {
  showTimModal: boolean;
  timUnreadCount: number;
  currentCampaignId: string;
  currentOrderId: string;
  /** iframe 已完成首次初始化（iframe 已挂载，src 不含 token） */
  timLoaded: boolean;
  /** iframe src（裸 URL，token 通过 SET_STATE AUTH 发送） */
  timUrl: string;
  setShowTimModal: (show: boolean, params?: OpenTimModalParams) => void;
  setTimUnreadCount: (count: number) => void;
  /** 幂等：首次调用时写入 timUrl 并标记 timLoaded=true */
  setTimReady: (url: string) => void;
};

const toStoreValue = (value?: string | number | null) =>
  value == null ? '' : String(value);

export const useTimModalStore = create<TimModalStore>()((set) => ({
  showTimModal: false,
  timUnreadCount: 0,
  currentCampaignId: '',
  currentOrderId: '',
  timLoaded: false,
  timUrl: '',
  setShowTimModal: (show, params) =>
    set(() => ({
      showTimModal: show,
      currentCampaignId: show ? toStoreValue(params?.campaignId) : '',
      currentOrderId: show ? toStoreValue(params?.orderId) : ''
    })),
  setTimUnreadCount: (count) => set({ timUnreadCount: count }),
  setTimReady: (url) =>
    set((state) => (state.timLoaded ? state : { timLoaded: true, timUrl: url }))
}));
